import {
	getNumberFieldValue,
	getSingleSelectFieldValue,
	getStringFieldValue,
} from './get-field-value';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fieldMap: Record<string, any> = {
	JiraUrlField: getStringFieldValue,
	JiraSingleLineTextField: getStringFieldValue,
	JiraNumberField: getNumberFieldValue,
	JiraSingleSelectField: getSingleSelectFieldValue,
};

export const prefillCustomFieldMap = ({
	gqlType,
	defaultValue,
	allowedValues,
}: {
	gqlType: string;
	defaultValue: unknown;
	allowedValues?: unknown;
}) => {
	if (typeof fieldMap[gqlType] !== 'function') return null;
	if (allowedValues) {
		return fieldMap[gqlType]({ defaultValue, allowedValues });
	}
	return fieldMap[gqlType](defaultValue);
};
